import tutoringImage1 from "./images/image_2.jpg";
import tutoringImage2 from "./images/image_3.jpg";
import tutoringImage3 from "./images/image_4.jpg";

const Services = () => {
  return (
    <section className="services_section py-16 px-6 bg-gradient-to-r from-blue-50 to-indigo-100">
      <div className="container mx-auto max-w-7xl">
        <div className="heading_container text-center mb-14">
          <h2 className="text-4xl font-extrabold text-gray-800 mb-4">
            Our Home Tuition Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We provide expert home tuition services across India, ensuring personalized education tailored to each student's unique needs.
          </p>
        </div>

        <div className="services_content grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Service 1 */}
          <div className="service bg-white rounded-2xl shadow-lg p-6 flex flex-col items-center text-center transition-transform hover:scale-105 hover:shadow-2xl">
            <img
              src={tutoringImage1}
              alt="Personalized Tutoring"
              className="w-full h-48 object-cover rounded-xl mb-5"
            />
            <h3 className="text-2xl font-semibold text-gray-800 mb-3">
              Personalized Tutoring
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Our qualified tutors create customized lesson plans to cater to individual learning styles, ensuring effective and engaging lessons.
            </p>
          </div>

          {/* Service 2 */}
          <div className="service bg-white rounded-2xl shadow-lg p-6 flex flex-col items-center text-center transition-transform hover:scale-105 hover:shadow-2xl">
            <img
              src={tutoringImage2}
              alt="Flexible Scheduling"
              className="w-full h-48 object-cover rounded-xl mb-5"
            />
            <h3 className="text-2xl font-semibold text-gray-800 mb-3">
              Flexible Scheduling
            </h3>
            <p className="text-gray-600 leading-relaxed">
              We understand the importance of flexibility. Our tutors work around your schedule to provide lessons at the most convenient times for you.
            </p>
          </div>

          {/* Service 3 */}
          <div className="service bg-white rounded-2xl shadow-lg p-6 flex flex-col items-center text-center transition-transform hover:scale-105 hover:shadow-2xl">
            <img
              src={tutoringImage3}
              alt="Subjects Covered"
              className="w-full h-48 object-cover rounded-xl mb-5"
            />
            <h3 className="text-2xl font-semibold text-gray-800 mb-3">
              Subjects Covered
            </h3>
            <p className="text-gray-600 leading-relaxed">
              We offer tutoring for a wide range of subjects, from mathematics and science to languages and arts, ensuring comprehensive support for all students.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
